const labelSideReducer = (state = { labelDisplay: [] }, action) => {
    switch (action.type) {
        case 'SIDEBAR_LABEL':
            return {
                ...state,
                labelDisplay: action.payload,
            };
        default:
            return state;
    }
};
const siteThemeReducer = (state = { siteTheme: {}, error: null, loading: false }, action) => {
    switch (action.type) {
        case 'GET_SITE_REQUEST':
            return {
                ...state,
                siteTheme: {},
                adminSetting: null,
                loading: true,
            };
        case 'GET_SITE_THEME':
            return {
                ...state,
                siteTheme: action.payload.Site_theme_setting[0],
                adminSetting: action.payload.adminSetting,
                loading: false
            };
        case 'GET_SITE_THEME_FAILED':
            return {
                ...state,
                siteTheme: {},
                error: action.payload,
                loading: true
            };
        default:
            return state;
    }
};
const languageCodeReducer = (state= { languageCode: {}, error: null}, action) => {
    switch (action.type) {
        case 'GET_LANGUAGE_CODE':
            return {
                ...state,
                languageCodeData: action.payload
            };
        case 'GET_LANGUAGE_CODE_FAILED':
            return {
                ...state,
                languageCode: {},
                error: action.payload,
            };
        default:
            return state;
    }
};
const userPermissionReducer = (state = { permissionData: {}, onlyPermission: [], error: null }, action) => {
    switch (action.type) {
        case 'GET_USER_PERMISSION':
            return {
                ...state,
                permissionData: action.payload,
                onlyPermission: action.payload?.data?.map((item) => item?.menu_id),
                userDetails: action.payload?.userDetails
            };
        case 'GET_USER_PERMISSION_FAILED':
            return {
                ...state,
                data: {},
                onlyPermission: [],
                error: action.payload
            };
        default:
            return state;
    }
};
const storageReducer = (state = { data: {}, error: null, loading: true }, action) => {
    switch (action.type) {
        case 'GET_STORAGE':
            return {
                ...state,
                data: action.payload?.Storage_setting,
                loading: false
            };
        case 'GET_STORAGE_FAILED':
            return {
                ...state,
                data: {},
                error: action.payload,
                loading: false
            };
        default:
            return state;
    }
};

export { labelSideReducer, siteThemeReducer, languageCodeReducer, userPermissionReducer, storageReducer } 
